import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import { MoveList } from 'chessboard/model/move-list/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create removeAnnotation action
 */
export function createRemoveAnnotation(
  _store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.RemoveAnnotation,
    action: CONTEXT_MENU_ACTION_NAMES.RemoveAnnotation,
    isVisible,
    handler,
  };

  /**
   * Visible if node has an annotation or additional annotation
   */
  function isVisible({ node }: ContextMenu.ActionHandlerContext) {
    const hasAnnotation = Boolean(node.annotation);
    const hasAdditionalAnnotation = Boolean(node.additionalAnnotation);
    return hasAnnotation || hasAdditionalAnnotation;
  }

  /**
   * handler to remove both annotations and additional annotations
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext): void {
    game.updateNode(node.ids, {
      annotation: undefined,
      additionalAnnotation: undefined,
    });
  }
}
